document.addEventListener('DOMContentLoaded', function () {
	document.querySelectorAll('.js-redirect-cookie').forEach((el) => {
		el.addEventListener('click', function (e) {
			console.log(e.currentTarget);
			console.log(e.currentTarget.firstChild);
			var cookieValue = e.currentTarget.firstChild.getAttribute('href');
			var domainValue = e.currentTarget.firstChild.getAttribute('data-domain');
			console.log('#########');
			var cookieDate = new Date();
			cookieDate.setFullYear(cookieDate.getFullYear() + 1);
			document.cookie = 'last_visited_site=' + cookieValue + '; expires=' + cookieDate.toGMTString() + '; path=/' + '; domain=' + domainValue + ';';
		});
	});
	document.querySelector('.js-burger').addEventListener('click', function () {
		this.classList.toggle('is-open');
		document.querySelector('.js-nav-main-menu').classList.toggle('is-open');
		document.querySelectorAll('.js-menu-item-has-dropdown.is-open').forEach((el) => {
			el.classList.remove('is-open');
		});
	});

	const tooltip = document.querySelector('.js-tooltip')
	if (tooltip) {
		document.querySelector('.js-tooltip').addEventListener('click', function () {
			tooltip.classList.toggle('is-open');
		});
	}
	document.querySelectorAll('.js-button-show-dropdown').forEach((el) => {
		el.addEventListener('click', function (e) {
			e.target.closest('.js-menu-item-has-dropdown').classList.toggle('is-open');
		});
	});
});
